<template>
    <div class="page-game">
        <content-item v-for="game in games" :title="game.app_name">
            <div class="game-item">
                <div class="app-icon" :style="'background: url(' + game.game_center_pic_url + ')'"></div>
                <div class="app-desc">
                    <div class="app-name">{{ game.app_name }}</div>
                    <div class="app-content">
                        <div class="left-info">
                            <p class="app-detail">{{ game.tips }}</p>
                            <a class="app-site" target="_blank" :href="game.detail_href">more<i class="fa fa-angle-double-right"></i> </a>
                        </div>
                        <div class="right-links">
                            <div class="app-links">
                                <a :href="game.app_store_href" v-if="game.app_store_href != ''" class="btn-apple"></a>
                                <a :href="game.google_play_href" v-if="game.google_play_href != '' && game.app_name !== '幻想英雄'" class="btn-google"></a>
                                <a :href="game.google_play_href" v-if="game.google_play_href != '' && game.app_name === '幻想英雄'" class="btn-taptap"></a>
                                <a :href="game.apk_href" v-if="game.apk_href != ''" class="btn-apk">
                                    {{ $t('download') }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </content-item>
    </div>
</template>

<script>

    import ContentItem from './partial/ContentItem.vue'
    import md5 from 'blueimp-md5'
    import globals from '../config/global'
    export default {
        data() {
            return {
                games:[]
            };
        },
        beforeMount(){
            if (globals.methods.getStorageItem('gameCenterData')) {
                this.games = JSON.parse(globals.methods.getStorageItem('gameCenterData'));
                return
            }
            let timeStamp = Date.parse(new Date());
            let sign = md5(timeStamp)
            let that = this
            let extraParam = '&platform=2'//1英卓，2萌果
            if(globals.isTest){//测试环境会获取未审核的内容
                extraParam += '&isTest=1'
            }
            this.$http.get(globals.enjoyUrl + 'enjoysiteapi/getgamecenter?timestamp=' + timeStamp + '&sign=' + sign + extraParam).then(
                function (response) {
                    that.games = response.data
                    globals.methods.setStorageItem('gameCenterData',that.games,3600)
                });

        },
        components: {
            ContentItem
        }
    };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../assets/scss/lib.scss";

    .page-game {
        margin-top: 30px;
    }

    .game-item {
        height: 247px + 28px * 2;
        width: 100%;
        @include flex-row-center;
        border-bottom: 1px solid #e0e0e0;
        box-sizing: border-box;
        padding: 0 25px;
        &:first-child {
            height: 247px + 28px;
            @include cross-top;
        }
        &:last-child {
            border-bottom: none;
        }
        .app-icon {
            width: 295px;
            height: 247px;
            @include flex-grow(0);
        }
    }

    .app-desc {
        height: 247px;
        @include flex-grow(1);
        margin-left: 30px;
        position: relative;
        @include flex;
        @include dir-top;
        .app-name {
            font-size: 22px;
            font-weight: bold;
            margin-bottom: 10px;
            @include flex-grow(0);
        }
        .app-content {
            @include flex-grow(1);
            @include flex;
            @include cross-top;
            height: 100%;
        }
    }

    .left-info {
        position: relative;
        height: 210px;
        width: 477px;
        @include flex;
        @include dir-top;
        @include main-justify;
        .app-detail {
            color: #616161;
            font-size: 16px;
            line-height: 25px;
            text-align: justify;
        }
        .app-site {
            color: $orange-color;
            font-size: 18px;
            align-self: flex-end;
        }
    }
    .right-links {
        height: 100%;
        margin-left: 30px;
        .app-links {
            @include flex-grow(0);
            @include flex;
            @include dir-top;
            @include cross-center;
            a {
                display: block;
                width: 136px;
                height: 45.6px;
                background-size: 136px 45.6px;
                margin-bottom: 8px;
            }
            .btn-apple {
                background-image: url(../../static/img/game/btn_apple.png);
            }
            .btn-google {
                background-image: url(../../static/img/game/btn_google.png);
            }.btn-taptap {
                background-image: url(../../static/img/game/btn_taptap.png);
            }
            .btn-one-store {
                background-image: url(../../static/img/game/btn_one_store.png);
            }
            .btn-apk {
                $width: 129px;
                $rate: 45.6 / 136;
                $height: $width * $rate - 5px;

                width: $width;
                height: $height;
                background-size: $width $height;
                background-image: url(../../static/img/game/btn_apk.png);
                @include flex-row-center;
                color: #fff;
                text-decoration: none;
                margin-top: 3px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Game.vue?033a8a34